import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";

import RouteAll from "./routes/RouteAll";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { MinimumPercentProvider } from "./utilities/MinimumPercentContext";
import { useSettings } from "./context/SettingsContext"; 

function App() {
  const { globalSettings } = useSettings();

  useEffect(() => {
    
    if (globalSettings) {
      
      if (globalSettings.primaryColor) {
        document.documentElement.style.setProperty('--primary', globalSettings.primaryColor);
        
        document.documentElement.style.setProperty('--primary-soft', `${globalSettings.primaryColor}1a`);
      }

      // Secondary Color Update
      if (globalSettings.secondaryColor) {
        document.documentElement.style.setProperty('--secondary', globalSettings.secondaryColor);
      }
    }
  }, [globalSettings]);

  return (
    <MinimumPercentProvider>
      <BrowserRouter>
        <RouteAll />
      </BrowserRouter>
    </MinimumPercentProvider>
  );
}

export default App;